// extracted by mini-css-extract-plugin
module.exports = {"container":"_jj","card":"_jk","closeButton":"_jl"};